// 导入样式文件
import './Settings.less';
// 导入React hooks
import { useEffect, useState, useRef, useCallback } from 'react';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';
// 导入设置存储图标
// import settingsStorage from '@/assets/settings/settings-storage.svg';
// import settingsWords from '@/assets/settings/setting-words.svg';
import write from '@/assets/settings/write.png';
import member from '@/assets/layouts/dashboard/member.png';
// 导入路由相关hook
import { useNavigate } from 'react-router-dom';
// 导入仪表板数据hook
import { useDashboardData } from '@/hooks/DashboardHooks';
// 导入移除token的工具函数
import { removeToken } from '@/utils/cookie';
// 导入用户服务API
import { authService, userService, infoController } from '@/api/index';
// 导入自定义API hook
import { useApi } from '@/hooks/useApi.jsx';
// 导入上传工具类
import Uploader from '@/utils/upload';

import { useDrawer } from '@/hooks/DrawerHooks';
import SentryTracker from '@/utils/Sentry/sentryUtils';
import { useTranslation } from 'react-i18next';
// 定义Settings组件
export default function Settings() {
  const { t } = useTranslation();
  // 渲染主组件
  return (
    <div className="settings_box">
      <div className="settings_title">
        {/* Account Settings */}
        {t('As_Settings_Title')}
      </div>
      <div className="settings_main">
        {/* <SettingMainLeft />
        <SettingMainRight /> */}
        <SettingMain />
      </div>
    </div>
  );
}

// 左侧设置组件
// function SettingMainLeft() {
//   const { t } = useTranslation();
//   // 获取用户数据和更新回调
//   const { userData, setChildCallback, avatarLoading, setAvatarLoading } = useDashboardData();
//   const [avatarTimestamp, setAvatarTimestamp] = useState(new Date().getTime());
//   const [username, setUsername] = useState('');
//   // 使用自定义hook修改用户昵称
//   const {
//     data: nicknameCallBackSuccess,
//     error: nicknameCallBackError,
//     execute: setNickname,
//   } = useApi(userService.setNickname);
//   // 监听用户名更新结果
//   useEffect(() => {
//     if (nicknameCallBackSuccess?.code === 0) {
//       setChildCallback(new Date().getTime());
//     } else if (nicknameCallBackError) {
//       console.log('修改用户名错误：', nicknameCallBackError);
//     }
//   }, [nicknameCallBackSuccess, nicknameCallBackError, setChildCallback]);
//   useEffect(() => {
//     setUsername(userData?.userInfo?.username || '');
//   }, [userData?.userInfo?.username]);

//   // 使用自定义hook修改用户头像
//   const {
//     data: avatarCallBackSuccess,
//     error: avatarCallBackError,
//     execute: setAvatar,
//   } = useApi(userService.setAvatar);

//   // 监听头像更新结果
//   useEffect(() => {
//     if (avatarCallBackSuccess?.code === 0) {
//       setChildCallback(new Date().getTime());
//       setAvatarTimestamp(new Date().getTime());
//     } else if (avatarCallBackError) {
//       console.log('修改用户名错误：', avatarCallBackError);
//     }
//   }, [avatarCallBackSuccess, avatarCallBackError, setChildCallback]);

//   // 处理用户名更改
//   const handleChangeName = (event) => {
//     const newName = event.target.value;
//     console.log(newName, 'newNamenewName');

//     if (newName === userData?.userInfo.username || !event.target.value) {
//       setUsername(userData?.userInfo.username);
//       return;
//     }
//     setNickname({
//       nickname: event.target.value,
//     });
//   };
//   const handleInputUsername = (event) => {
//     setUsername(event.target.value);
//   };
//   // 获取导航函数
//   const navigate = useNavigate();

//   // 处理登出
//   const handleSignOut = async () => {
//     await authService.logout();
//     // removeToken();
//     navigate('/login');
//   };

//   // 上传回调函数
//   const uploadCallback = (val) => {
//     console.log(val, 'valvalval');
//   };

//   // 处理头像上传
//   const handleUploadAvatar = async (event) => {
//     const file = event.target.files[0];
//     console.log(file);
//     const fileExtension = file.name.split('.').pop();
//     setAvatarLoading(true);
//     try {
//       const upload = new Uploader(2, uploadCallback, { ext: fileExtension });
//       await upload.uploadFile(file);
//       const res = await upload.complete();
//       console.log(res);
//       setAvatar({
//         uploadId: res.uploadId,
//         completedParts: res.eTags,
//       });
//     } catch (error) {
//       console.log('结束上传', error);
//     }
//     setAvatarLoading(false);
//   };
//   return (
//     <div className="setting_main_left">
//       <div className="title">
//         {/* Profile */}
//         {t('As_Settings_Profile')}
//       </div>
//       {avatarLoading ? (
//         <div className="skeleton shrink-0 rounded-full"></div>
//       ) : (
//         <div className="head_portrait">
//           <img
//             className="head_portrait_img"
//             src={`${userData?.userInfo?.avatar}?timestamp=${avatarTimestamp}`}
//             alt=""
//           />
//           <input
//             type="file"
//             accept="image/*"
//             onChange={handleUploadAvatar}
//             className="file-input file-input-bordered file-input-xs uploadinput"
//           />
//         </div>
//       )}

//       <div className="input_box">
//         <div className="text">
//           {/* Name */}
//           {t('As_Settings_Name')}
//         </div>
//         <input
//           type="text"
//           value={username}
//           onInput={handleInputUsername}
//           maxLength={200}
//           onBlur={handleChangeName}
//           onKeyDown={(e) => {
//             if (e.key === 'Enter') {
//               e.target.blur();
//             }
//           }}
//           placeholder="User Name"
//           className="input input-bordered w-full"
//         />
//       </div>
//       <div className="input_box">
//         <div className="text">
//           {/* Email Address */}
//           {t('As_Settings_Email')}
//         </div>
//         <input
//           type="text"
//           defaultValue={userData?.userInfo?.email}
//           placeholder="User Email Address"
//           className="input input-bordered w-full"
//           disabled
//           readOnly
//         />
//       </div>
//       <button className="signout" onClick={handleSignOut}>
//         <Icon tabIndex={0} name="icon-out" className="signouticon" />
//         <span className="text">
//           {/* Sign out */}
//           {t('As_Nav_Avatar2')}
//         </span>
//       </button>
//     </div>
//   );
// }

// 右侧设置组件
// function SettingMainRight() {
//   const { t } = useTranslation();
//   // 获取用户数据和更新回调
//   const { userData } = useDashboardData();
//   return (
//     <div className="setting_main_right">
//       <div className="title">
//         {/* My plan */}
//         {t('As_Settings_MyPlan')}
//       </div>
//       {userData?.userSubscription?.level <= 1 ? <FreeSubscription /> : <PaidSubscription />}
//     </div>
//   );
// }

// 免费订阅组件
// function FreeSubscription() {
//   const { t } = useTranslation();
//   const { setIsOpen } = useDrawer();
//   const { userData } = useDashboardData();
//   // 跳转到定价页面
//   const goToPricingPage = () => {
//     // navigate('/pricing');
//     SentryTracker.captureEvent('settingspage_upgrade_click', userData?.userInfo?.email);
//     setIsOpen(true);
//   };
//   return (
//     <div className="free_box">
//       <div className="free_top">
//         <div className="left">
//           <div className="free_title">
//             {/* Standard */}
//             {t('As_Home_CardStandard')}
//           </div>
//           <div className="free_compare" onClick={goToPricingPage}>
//             {/* Compare plans */}
//             {t('As_Settings_Compare')}
//           </div>
//         </div>
//       </div>
//       <div className="free_btm">
//         <div className="btm_title">
//           {/* Standard plan has a 1 video limit
//           <br />
//           Upgrade to unlock unlimited videos */}
//           {t('As_Home_Limit2')}
//         </div>
//         <button onClick={goToPricingPage} className="btn btn-primary upgrade_btn1">
//           {/* Upgrade */}
//           {t('As_Recording_Upgrade')}
//         </button>
//       </div>
//     </div>
//   );
// }

// 配额项组件
// function QuotaItem({ icon, name, used, quota, unit, period }) {
//   const { t } = useTranslation();
//   let usagePercentage = 0;
//   const quotaDisplay = period ? `${quota} ${unit} / ${period}` : `${quota} ${unit}`;
//   if (unit === 'min' && quota === 0 && used === 0) {
//     usagePercentage = 0;
//   } else {
//     usagePercentage = Math.round((used / quota) * 100);
//   }

//   return (
//     <div className="quota_item">
//       <div className="flex justify-between items-center h-7.5">
//         <div className="flex items-center text-[color:oklch(var(--bc))] text-[14px] leading-[14px]">
//           {icon && <img src={icon} alt="" className="w-5 mr-0.5" />}
//           <span>{t(name)}</span>
//         </div>
//         <div className="mt-0.75 opacity-50 text-[color:oklch(var(--bc))] text-[14px] leading-[14px]">
//           {quotaDisplay}
//         </div>
//       </div>
//       <div className="quota_info calculation w-full h-8 bg-[oklch(var(--b3))] rounded-lg overflow-hidden relative">
//         <div
//           className={`quota_progress h-full bg-[oklch(var(--p))] rounded-lg absolute progress ${usagePercentage >= 100 ? 'progress_full' : ''}`}
//           style={{ width: `${usagePercentage}%` }}>
//           <span className="usage_text usage_text_inside">
//             {unit === 'words' || unit === 'min'
//               ? `${used.toFixed(0)} ${unit} used`
//               : `${used.toFixed(2)} ${unit} used`}
//           </span>
//         </div>

//         <span className="usage_text usage_text_outside">
//           {unit === 'words' || unit === 'min'
//             ? `${used.toFixed(0)} ${unit} used`
//             : `${used.toFixed(2)} ${unit} used`}
//         </span>
//       </div>
//     </div>
//   );
// }

// 付费订阅组件
// function PaidSubscription() {
//   const { t } = useTranslation();
//   const getInfoController = async () => {
//     try {
//       const res = await infoController.orderManage();
//       if (res?.code === 0) {
//         window.open(res.data.url);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   // 获取用户数据和更新回调
//   const { userData } = useDashboardData();
//   const { setIsOpen } = useDrawer();
//   // 跳转到定价页面
//   const goToPricingPage = () => {
//     // navigate('/pricing');
//     window.onClickGATrackEvent('settings-upgrade');
//     setIsOpen(true);
//   };
//   const PaidName = () => {
//     if (userData?.userSubscription?.level >= 1) {
//       if (userData?.userSubscription?.level === 2) {
//         return (
//           <div className="paid_title">
//             {/* Starter */}
//             {t('As_Home_CardStarter')}
//           </div>
//         );
//       } else if (userData?.userSubscription?.level === 3) {
//         return (
//           <div className="paid_title">
//             {/* Creator */}
//             {t('As_Home_CardCreator')}
//           </div>
//         );
//       } else {
//         return (
//           <div className="paid_title">
//             {/* Standard */}
//             {t('As_Home_CardStandard')}
//           </div>
//         );
//       }
//     } else {
//       return (
//         <div className="paid_title">
//           {/* Standard */}
//           {t('As_Home_CardStandard')}
//         </div>
//       );
//     }
//   };
//   return (
//     <div className="paid_box">
//       <div className="paid_top">
//         <div className="left">
//           {PaidName()}

//           <div className="paid_compare" onClick={goToPricingPage}>
//             {/* Compare plans */}
//             {t('As_Settings_Compare')}
//           </div>
//         </div>
//         {userData?.userSubscription?.level <= 1 ? (
//           <button className="btn btn-primary upgrade_btn" onClick={goToPricingPage}>
//             {/* Upgrade */}
//             {t('As_Recording_Upgrade')}
//           </button>
//         ) : (
//           <button className="btn btn-primary upgrade_btn" onClick={getInfoController}>
//             {/* Manage */}
//             {t('As_Settings_Manage')}
//           </button>
//         )}
//       </div>
//       <div className="paid_btm">
//         <div className="settings_quota_item space-y-8">
//           {JSON.stringify(userData) !== '{}' && (
//             <>
//               <QuotaItem
//                 icon={settingsStorage}
//                 name="Storage"
//                 used={
//                   userData.userSubscription.storageUsed
//                     ? userData.userSubscription.storageUsed / 1024 / 1024
//                     : userData.userSubscription.storageUsed
//                 }
//                 quota={
//                   userData.userSubscription.storageQuota
//                     ? (userData.userSubscription.storageQuota / 1024 / 1024).toFixed(1)
//                     : userData.userSubscription.storageQuota
//                 }
//                 unit="GB"
//                 period={null}
//               />
//               <QuotaItem
//                 icon={settingsWords}
//                 name="AI Transcript"
//                 used={userData.userSubscription.transcriptUsed / 1000 / 60 / 60}
//                 quota={(userData.userSubscription.transcriptQuota / 1000 / 60 / 60).toFixed(1)}
//                 unit="Hrs"
//                 period="Monthly"
//               />
//               <QuotaItem
//                 icon={settingsWords}
//                 name="AI Generate words"
//                 used={userData.userSubscription.aiDubbingUsed}
//                 quota={userData.userSubscription.aiDubbingQuota}
//                 unit="words"
//                 period="Monthly"
//               />
//               <QuotaItem
//                 icon={settingsWords}
//                 name="AI Translate"
//                 used={
//                   userData.userSubscription.translationQuota -
//                   userData.userSubscription.translationQuotaRemaining
//                 }
//                 quota={userData.userSubscription.translationQuota}
//                 unit="min"
//                 period="Monthly"
//               />
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// 新版UI
function SettingMain() {
  const { t } = useTranslation();
  const { userData, setChildCallback, avatarLoading, setAvatarLoading } = useDashboardData();
  const { setIsOpen } = useDrawer();
  const [avatarTimestamp, setAvatarTimestamp] = useState(new Date().getTime());
  const [isEditing, setIsEditing] = useState(false);
  const [username, setUsername] = useState('');
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [pointsInfo, setPointsInfo] = useState({});
  const order = ['As_Settings_Plan1', 'As_Settings_Plan2', 'As_Settings_Plan3'];

  // 使用自定义hook修改用户头像
  const {
    data: avatarCallBackSuccess,
    error: avatarCallBackError,
    execute: setAvatar,
  } = useApi(userService.setAvatar);

  // 监听头像更新结果
  useEffect(() => {
    if (avatarCallBackSuccess?.code === 0) {
      setChildCallback(new Date().getTime());
      setAvatarTimestamp(new Date().getTime());
    } else if (avatarCallBackError) {
      console.log('修改用户名错误：', avatarCallBackError);
    }
  }, [avatarCallBackSuccess, avatarCallBackError, setChildCallback]);

  // 上传回调函数
  const uploadCallback = (val) => {
    console.log(val, 'valvalval');
  };

  // 上传头像
  const handleUploadAvatar = async (event) => {
    const file = event.target.files[0];
    const fileExtension = file.name.split('.').pop();
    setAvatarLoading(true);
    try {
      const upload = new Uploader(2, uploadCallback, { ext: fileExtension });
      await upload.uploadFile(file);
      const res = await upload.complete();
      console.log(res);
      setAvatar({
        uploadId: res.uploadId,
        completedParts: res.eTags,
      });
    } catch (error) {
      console.log('结束上传', error);
    }
    setAvatarLoading(false);
  };

  // 使用自定义hook修改用户昵称
  const {
    data: nicknameCallBackSuccess,
    error: nicknameCallBackError,
    execute: setNickname,
  } = useApi(userService.setNickname);
  // 监听用户名更新结果
  useEffect(() => {
    if (nicknameCallBackSuccess?.code === 0) {
      setChildCallback(new Date().getTime());
      setIsEditing(false);
    } else if (nicknameCallBackError) {
      console.log('修改用户名错误：', nicknameCallBackError);
    }
  }, [nicknameCallBackSuccess, nicknameCallBackError, setChildCallback]);
  useEffect(() => {
    setUsername(userData?.username || '');
  }, [userData?.username]);

  // 处理用户名更改
  const handleChangeName = (event) => {
    const newName = event.target.value;
    if (newName === userData?.username || !event.target.value) {
      setUsername(userData?.username);
      setIsEditing(false);
      return;
    }
    setNickname({
      username: event.target.value,
    });
  };
  const handleInputUsername = (event) => {
    setUsername(event.target.value);
  };

  const showInput = () => {
    setIsEditing(true);
  };

  const handleStateChange = useCallback(() => {
    if (isEditing) {
      inputRef.current && inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    handleStateChange();
  }, [isEditing, handleStateChange]);

  const timeformat = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  // 跳转到定价页面
  const goToPricingPage = (type) => {
    if (type == 0) {
      window.onClickGATrackEvent('settings-upgrade');
    } else if (type == 2) {
      window.onClickGATrackEvent('settings-get-more');
    }
    localStorage.setItem('pricing_type', type);
    SentryTracker.captureEvent('settingspage_upgrade_click', userData?.email);
    setIsOpen(true);
  };

  // 查看订阅
  const handleViewSubscription = async () => {
    try {
      const res = await infoController.orderManage();
      if (res?.code === 0) {
        console.log(res, 'success');
        window.open(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSignOut = async () => {
    window.onClickGATrackEvent('settings-sign-out');
    await authService.logout();
    removeToken();
    navigate('/login');
  };

  useEffect(() => {
    const points = userData?.points || [];
    const data = points?.filter((res) => res.number && res.expireTime);
    const info = data.sort((a, b) => {
      if (a.expireTime < b.expireTime) {
        return -1;
      } else if (a.expireTime > b.expireTime) {
        return 1;
      } else {
        return b.type - a.type;
      }
    });
    setPointsInfo(info[0]);
    console.log(info);
  }, [userData]);

  return (
    <div className="setting">
      <div className="title">
        {/* Profile */}
        {t('As_Settings_Profile')}
      </div>
      <div className="profile">
        {avatarLoading ? (
          <div className="skeleton shrink-0 rounded-full"></div>
        ) : (
          <div className="head_portrait">
            <img
              className="head_portrait_img"
              src={`${userData?.avatar}?timestamp=${avatarTimestamp}`}
              alt=""
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleUploadAvatar}
              className="file-input file-input-bordered file-input-xs uploadinput"
            />
          </div>
        )}
        <div className="info">
          {isEditing ? (
            <input
              type="text"
              value={username}
              onInput={handleInputUsername}
              maxLength={200}
              onBlur={handleChangeName}
              ref={inputRef}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.target.blur();
                }
              }}
              placeholder="User Name"
              className="input input-bordered w-full input_name"
            />
          ) : (
            <div className="name" onClick={showInput}>
              <span>{userData.username}</span>
              <img src={write} className="write" />
            </div>
          )}
          <div className="email">{userData.email}</div>
        </div>
      </div>
      <div className="title">
        {/* My plan */}
        <span>{t('As_Settings_UserSubscriptionOption')}</span>
        {userData.subscription?.id > 1 && (
          <span onClick={handleViewSubscription} style={{ cursor: 'pointer' }}>
            {t('As_Settings_ManageUserPlan')}
          </span>
        )}
      </div>
      <div className="subscribe">
        <div className="order">
          <span className="order_name">{t(order[userData.subscription?.id - 1])}</span>
          {userData.subscription?.id > 1 && (
            <span className="order_time">
              {t('As_Settings_Renewdate')}:{' '}
              {timeformat(userData.subscriptionExpire || userData.unsubscriptionTime)}
            </span>
          )}
        </div>
        <div className="credit">
          <div className="credit_info">
            <span className="credit_title">{t('As_Settings_Credits')}</span>
            <img src={member} className="credit_pic" />

            <div
              className="tooltip"
              data-tip={
                pointsInfo?.expireTime
                  ? `${pointsInfo.number} ${t('As_Space_CreditsExpire334')} ${timeformat(pointsInfo.expireTime)}`
                  : ''
              }>
              <span className="credit_num">{userData.actualTotalPoints}</span>
            </div>
          </div>
          <div className="get_credit" onClick={() => goToPricingPage(2)}>
            {t('As_Settings_MoreCredits')}
          </div>
        </div>
        <button className="btn btn-primary btn-xs upgrade" onClick={() => goToPricingPage(0)}>
          {t('As_Settings_CardUpgrade')}
        </button>
      </div>
      <div className="setting_tip">
        <div className="tip_q">{t('As_Settings_Feedbackinvitation')}</div>
        <div
          className="tip_a"
          onClick={() => {
            window.onClickGATrackEvent('settings-contact-us');
            window.open('https://forms.gle/8hW7aNYcAz1GhFtn7', '_black');
          }}>
          {t('As_Settings_Contact')}
        </div>
      </div>
      <button className="signout" onClick={handleSignOut}>
        <span className="text">
          {/* Sign out */}
          {t('As_Settings_SignOut')}
        </span>
        <Icon tabIndex={0} name="icon-out" className="signouticon" />
      </button>
    </div>
  );
}
